import { render, staticRenderFns } from "./slinvitetender-add-or-update.vue?vue&type=template&id=2595c3f0&"
import script from "./slinvitetender-add-or-update.vue?vue&type=script&lang=js&"
export * from "./slinvitetender-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports